"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _creatExpress = _interopRequireDefault(require("@/views/systemSetting/logisticsManagement/creatExpress.vue"));
var _useOrder = require("@/hooks/use-order");
var _default2 = require("@/views/systemSetting/deliveryPersonnel/default");
var _deliveryPersonnel = require("@/api/deliveryPersonnel");
var _creatPersonnel = _interopRequireDefault(require("@/views/systemSetting/deliveryPersonnel/creatPersonnel"));
var _permission = require("@/utils/permission");
var _systemSetting = require("@/api/systemSetting");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _logistics = require("@/api/logistics");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'sendFrom',
  components: {
    CreatExpress: _creatExpress.default,
    CreatPersonnel: _creatPersonnel.default
  },
  data: function data() {
    return {
      selectedValue: null,
      express: [],
      dialogVisible: false,
      editData: Object.assign({}, _default2.defaultData),
      tableFrom: {
        page: 1,
        limit: 9999
      },
      personnelList: [],
      shipmentExpress: {},
      // 电子面单发货信息
      exportTempList: [],
      merElectPrint: _jsCookie.default.get('merElectPrint'),
      // 商家小票打印开关状态
      currentItemCode: ''
    };
  },
  props: {
    formItem: {
      type: Object,
      default: null
    },
    isShowBtn: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.getList();
    this.getPersonnelList();
    //if (checkPermi(['admin:pass:shipment:express']))
    this.getShipmentExpress();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //选择配送员
    handleChangePersonnel: function handleChangePersonnel(e) {
      this.formItem.deliveryCarrier = e.personnelName;
      this.formItem.carrierPhone = e.personnelPhone;
    },
    // 取消选配送员弹窗
    handlerCloseFrom: function handlerCloseFrom() {
      this.dialogVisible = false;
    },
    // 选配送员确定回调
    handlerSuccessSubmit: function handlerSuccessSubmit() {
      this.getPersonnelList();
      this.dialogVisible = false;
    },
    // 配送员列表
    getPersonnelList: function () {
      var _getPersonnelList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _deliveryPersonnel.personnelListApi)(this.tableFrom);
            case 1:
              data = _context.v;
              this.personnelList = data.list;
              if (!this.isShowBtn) this.selectedValue = this.personnelList.filter(function (item) {
                return item.personnelPhone === _this.formItem.carrierPhone;
              })[0];
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getPersonnelList() {
        return _getPersonnelList.apply(this, arguments);
      }
      return getPersonnelList;
    }(),
    // 添加
    handleCreatPersonnel: function handleCreatPersonnel(row) {
      this.editData = row ? row : Object.assign({}, _default2.defaultData);
      this.dialogVisible = true;
    },
    // 添加
    handleCreat: function handleCreat() {
      if (!localStorage.getItem('expressAllList')) this.$refs.craetExpressRef.getExpressList();
      this.$refs.craetExpressRef.dialogVisible = true;
    },
    // 物流公司列表
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var params;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                keywords: '',
                page: 1,
                limit: 50,
                openStatus: true
              };
              _context2.n = 1;
              return (0, _useOrder.useLogistics)(params);
            case 1:
              this.express = _context2.v;
              this.express.map(function (item) {
                if (item.isDefault && !_this2.formItem.id) _this2.formItem.expressCode = item.code;
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    getShipmentExpress: function getShipmentExpress() {
      var _this3 = this;
      (0, _systemSetting.merchantElectrSheetInfo)().then(function (data) {
        _this3.shipmentExpress = data;
        _this3.formItem.toName = data.senderUsername;
        _this3.formItem.toTel = data.senderPhone;
        _this3.formItem.toAddr = data.senderAddr;
      });
    },
    changeSendTypeRadio: function changeSendTypeRadio(expressRecordType) {
      if (expressRecordType === '2') {
        this.formItem.expressCode && this.exportTemp(this.formItem.expressCode);
        this.getShipmentExpress();
      }
    },
    // 快递公司选择
    onChangeExpress: function onChangeExpress(val) {
      var currentItem = this.express.filter(function (item) {
        return item.code == val;
      })[0];
      this.formItem.expressName = val.name;
      this.formItem.expressTempId = '';
      this.currentItemCode = currentItem.code;
      if (this.formItem.expressRecordType === '2') this.exportTemp(currentItem.code);
    },
    // 电子面单模板
    exportTemp: function exportTemp(code) {
      var _this4 = this;
      (0, _logistics.exportTempApi)({
        com: code
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this4.exportTempList = res.data.data || [];
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    onChangeImg: function onChangeImg(item) {
      var _this5 = this;
      this.exportTempList.map(function (i) {
        if (i.temp_id === item) _this5.tempImg = i.pic;
      });
    }
  }
};